module.exports = require('./IntroImages')